export default "__VITE_ASSET__DiFPRpEe__"